import React, { useEffect, useContext, useState, useCallback } from "react";
import { getDailyWorkoutProgress, getLogs } from "../../../services/firebase/firestore/getData";
import "./Workout.scss";
import Check from "./check.png";
import Popup from "../../_default/Popup";


export default function Workout({ client_id, time }) {
  const [workout, setWorkout] = useState(false);
  const [logs, setLogs] = useState(false);
  const [LoggingBtn,setLoggingBtn]=useState(false)
  const [exerciseId,setExerciseId]=useState("");
  const [supersets,setSupersets]=useState([])
  let [sets,setSets]=useState(0)
  let count = 0;
  let alfabeth = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  useEffect(() => {
    localStorage.removeItem("tabIndex")
    console.log("time_workout", time);
    getDailyWorkoutProgress(client_id, time, (result) => {
        setWorkout(result);
       
        console.log("workout",result);
        setSupersets(result.supersets)
       
        console.log(client_id, time);
        // "2023-02-06" // testing
        getLogs(client_id, time, (result) => {
          console.log("logs",result);
          setLogs(result); //to much important
      })
    })
    
    console.log("workout sets",workout.supersets)
    // workout.supersets.map((data)=>{
    //   // debugger
    //     // SetsetId(data.id)
    //     console.log("data",data)
    //     data.exercises.map((ele)=>{
          
    //       return setExerciseId(ele.exercise_id)
    //       // console.log("data",ele.exercise_id,ele.id)
    //       // setExidx(ele.id)
          
    //     })
    //   })
      
     
   

  }, [time, client_id,LoggingBtn])

  return (
    <div className="c-workout-wrapper">
      <div className="c-workout-content">
        {workout?.supersets && workout?.supersets.map((__item, key) => {
          count++;
          return <>
                  {/* {()=>SetsetId(__item.id)} */}
                  <h2 className="c-workout-title">{alfabeth[key]} - Series</h2>  
                  <div className="c-workout-item-grid" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {__item.exercises && __item.exercises.map((item, _key) => {
                      return (<>
                              <div key={item.id + Math.random()*5000} className="c-workout-item">
                                <img className="c-workout-item--img" src={item?.completed? Check : ""}/>
                                <div>
                                  <h3 className="c-workout-item--title">{alfabeth[key]}{ _key+1 }. {item.name}</h3>
                                  <span className="c-workout-item--count">
                                   {item.sets} sets  - {item.reps}-{item.maxReps} reps  - Tempo {item.up}.{item.up_pause}.{item.down}.{item.down_pause} - Rest {item.rest_time_in_minutes}'' { item.kg && '- '+item.kg+'kg' }
                                  </span>

                                </div>
                              </div>
                              <button className="set-log-btn" onClick={()=>{setLoggingBtn(true);setSets(item.sets);setExerciseId(item.id)}} >Set logging</button>
                              <div key={item.id + Math.random()*5000} className="c-workout-item" style={{ paddingLeft: 60 }}>
                                {/* <div>
                                  
                                  { (logs && item.subexercises[0].id) ? (
                                      <>
                                        {
                                          logs[item.subexercises[0].id]?.reps && logs[item.subexercises[0].id].reps.map((subitem, key) => {
                                            return (<span className="c-workout-item--count"  style={{ paddingBottom: 10, float: 'left', width: '100%', fontStyle:'normal' }}>
                                              <strong>Repetitions: </strong>{ logs[item.subexercises[0].id].reps[key] } - 
                                              <strong> Resistance: </strong>{ logs[item.subexercises[0].id].weight[key] }
                                              <strong> Notes: </strong>{ logs[item.subexercises[0].id].notes[key] }
                                            </span>);
                                          })

                                        }
                                      </>
                                    ) : <></>
                                  }
                                </div> */}
                              </div>
                              <p className="c-workout-item--kg"></p>
                              
                            </>)

                    })}
                  </div>
                </>
        })}
        {!workout? <p className="c-mealplan-empty">The client does not have a workout planned on this day.</p> : ""}  
      </div> 
      {
        LoggingBtn&&
        <Popup 
        title={"Set Logging"}
        isSetLoging={true}
        button="Save"
        deletePopup={true}
        onCancel={() => {
				  setLoggingBtn(false);
				}}
        sets={sets}
        client_id={client_id}
        supersets={supersets}
        setLoggingBtn={setLoggingBtn}
        getLogs={logs}
        exerciseId={exerciseId}
        date={time}
        />
      }
    </div>
  );
}
